import * as THREE from 'three'

export const injectFakeAO = (function () {
    const fakeAOFrag = `

vec3 worldPosition = ( modelMatrix * vec4( vPosition, 1.0 )).xyz - center;
float fragRadius = length(worldPosition);
float shadowStrength = max(0.0, 1.0 - (strength * (1.0 / (attenuation * (fragRadius - startRadius) + 1.0))));
gl_FragColor.rgb = gl_FragColor.rgb * shadowStrength;`

    const vPositionDef = "\nvarying vec3 vPosition;\n"
    const vPositionSet = "\nvPosition = position;\n"
    const uMatMatrix = "\nuniform mat4 modelMatrix;\n"

    const uniforms = {
        color: { value: new THREE.Vector3(1, 1, 1) },
        center: { value: new THREE.Vector3(0, 50, 0) },
        attenuation: { value: 0.5 },
        strength: { value: 0.9 },
        startRadius: { value: 49.5 },
    }

    let declarations = ""
    const uniformPostfix = ""
    let type = ""
    // let assignment = ""

    return function injectFakeAO(shader, renderer) {
        declarations = ""

        for (const key in uniforms) {
            const newKey = key + uniformPostfix
            if (newKey in shader.uniforms) {
                console.log(
                    "WARNING: Key " +
                        key +
                        " already in rim light shader uniforms: ",
                    shader.uniforms
                )
                continue
            }

            type = ""
            // assignment = ""
            if (uniforms[key].value.isVector3) {
                type = "vec3"
                // assignment = "vec3(" + uniforms[key].value.x.toFixed(5) + ", " + uniforms[key].value.y.toFixed(5) + ", " + uniforms[key].value.z.toFixed(5) + ");";
            } else if (typeof uniforms[key].value === "number") {
                type = "float"
                // assignment = uniforms[key].value.toFixed(5);
            } else {
                console.log(
                    "ERROR: injectFakeAO: Unknown type passed in uniforms as " +
                        key +
                        ":",
                    uniforms[key],
                    uniforms[key].value.isVector3,
                    typeof uniforms[key].value
                )
                return
            }
            declarations += "uniform " + type + " " + newKey + ";"
            shader.uniforms[newKey] = uniforms[key]
        }

        shader.vertexShader = shader.vertexShader.replace(
            "void main() {",
            vPositionDef + "void main() {" + vPositionSet
        )

        // Modify frag shader
        shader.fragmentShader = shader.fragmentShader.replace(
            "void main() {",
            declarations + uMatMatrix + vPositionDef + "void main() {"
        )

        shader.fragmentShader = shader.fragmentShader.replace(
            "#include <dithering_fragment>",
            "#include <dithering_fragment>" + fakeAOFrag
        )
    }
})()

export const injectFakeAO_UV = (function () {
    const fakeAOFrag = `

float factor = vUv.x * vUv.x;
gl_FragColor.rgb = gl_FragColor.rgb * ((factor / 4.0) + 0.75);`

    const uniforms = {
        color: { value: new THREE.Vector3(1, 1, 1) },
        center: { value: new THREE.Vector3(0, 50, 0) },
        // +x is right
        // +y is up
        // +z is away (don't use)
        attenuation: { value: 2 },
        strength: { value: 0.25 },
        startRadius: { value: 52 },
    }

    const vUvDef = "\nvarying vec2 vUv;\n"
    const vUvSet = "\nvUv = uv;\n"

    const constantDeclarations = "\nvarying vec2 vUv;\n"
    const uniformPostfix = ""
    let declarations = ""
    let type = ""
    // let assignment = ""

    return function injectFakeAO(shader, renderer) {
        declarations = ""

        for (const key in uniforms) {
            const newKey = key + uniformPostfix
            if (newKey in shader.uniforms) {
                console.log(
                    "WARNING: Key " +
                        key +
                        " already in rim light shader uniforms: ",
                    shader.uniforms
                )
                continue
            }

            type = ""
            // assignment = ""
            if (uniforms[key].value.isVector3) {
                type = "vec3"
                // assignment = "vec3(" + uniforms[key].value.x.toFixed(5) + ", " + uniforms[key].value.y.toFixed(5) + ", " + uniforms[key].value.z.toFixed(5) + ");";
            } else if (typeof uniforms[key].value === "number") {
                type = "float"
                // assignment = uniforms[key].value.toFixed(5);
            } else {
                console.log(
                    "ERROR: injectFakeAO: Unknown type passed in uniforms as " +
                        key +
                        ":",
                    uniforms[key],
                    uniforms[key].value.isVector3,
                    typeof uniforms[key].value
                )
                return
            }
            declarations += "uniform " + type + " " + newKey + ";"
            shader.uniforms[newKey] = uniforms[key]
        }

        shader.vertexShader = shader.vertexShader.replace(
            "void main() {",
            vUvDef + "void main() {" + vUvSet
        )

        // Modify frag shader
        shader.fragmentShader = shader.fragmentShader.replace(
            "void main() {",
            declarations + constantDeclarations + "void main() {"
        )

        shader.fragmentShader = shader.fragmentShader.replace(
            "#include <dithering_fragment>",
            "#include <dithering_fragment>" + fakeAOFrag
        )

        // console.log(shader.fragmentShader);
    }
})()